import { render } from "./ListPhApproveView.vue?vue&type=template&id=c644dec2"
import script from "./ListPhApproveView.vue?vue&type=script&lang=js"
export * from "./ListPhApproveView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__